import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      const hashSessionIdMatch = hash.match(/session_id=([^&]+)/);
      const searchParams = new URLSearchParams(location.search);
      const sessionId =
        hashSessionIdMatch?.[1] || searchParams.get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        const { data } = await axios.post(
          `${BACKEND_URL}/api/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        
        setUser(data);
        navigate('/products', { state: { user: data }, replace: true });
      } catch (error) {
        console.error('Session exchange failed:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAF7]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#8C1B2F] mx-auto"></div>
        <p className="mt-4 text-[#5C5C5C]">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
